'use es6';

// https://git.hubteam.com/HubSpot/Cerebro/blob/a8333f3199d794eeff0e0e1eaa8fd193b3cb423f/static/coffee/constants/PropertyOperators.coffee#L149
// https://git.hubteam.com/HubSpot/Contacts/blob/0fc7e34c4c8c466318e8d6477732b482cf602d43/ContactsApiClient/src/main/java/com/hubspot/contactsapi/views/filters/FilterOperatorSets.java
export const AFTER = 'compare_GT';
export const BEFORE = 'compare_LT';
export const BETWEEN = 'BETWEEN';
export const CONTAIN = 'CONTAINS';
export const CONTAIN_ALL = 'SET_ALL';
export const CONTAIN_ALL_TEAMS = 'CONTAIN_ALL_TEAMS';
export const ENDS_WITH = 'STR_ENDS_WITH';
export const EQUAL = 'EQ';
export const EQUAL_ALL = 'SET_EQ';
export const EQUAL_ANY = 'EQ_MULTI';
export const EVER_CONTAINED_ALL = 'history_SET_EQ';
export const EVER_CONTAINED_ANY = 'history_CONTAINS';
export const EVER_EQUAL = 'history_EQ';
export const EVER_EQUAL_ANY = 'history_EQ_MULTI';
export const EVER_IN = 'history_SET_ANY';
export const GREATER = 'GT';
export const GREATER_OR_EQUAL = 'GTE';
export const GREATER_THAN_ROLLING = 'WITHIN_TIME_REVERSE';
export const IN = 'SET_ANY';
export const KNOWN = 'IS_NOT_EMPTY';
export const LESS = 'LT';
export const LESS_OR_EQUAL = 'LTE';
export const LESS_THAN_ROLLING = 'WITHIN_TIME';
export const NOT_BETWEEN = 'NOT_BETWEEN';
export const NOT_CONTAIN = 'DOESNT_CONTAIN';
export const NOT_CONTAIN_ALL = 'SET_NOT_ALL';
export const NOT_EQUAL = 'NEQ';
export const NOT_EQUAL_ALL = 'SET_NEQ';
export const NOT_EQUAL_ANY = 'NEQ_MULTI';
export const NOT_EVER_CONTAINED_ALL = 'history_SET_NEQ';
export const NOT_EVER_CONTAINED_ANY = 'history_SET_NOT_ANY';
export const NOT_EVER_EQUAL = 'history_NEQ';
export const NOT_EVER_EQUAL_ANY = 'history_NEQ_MULTI';
export const NOT_IN = 'SET_NOT_ANY';
export const NOT_KNOWN = 'IS_EMPTY';
export const STARTS_WITH = 'STR_STARTS_WITH';
// PRIVACY CONSENT (Subtype of Contact property in the UI)
export const HAS_PRIVACY_CONSENT = 'HAS_PRIVACY_CONSENT';
export const HAS_NOT_PRIVACY_CONSENT = 'HAS_NOT_PRIVACY_CONSENT';

// CTA
export const CTA_HAS_CLICKED = 'HAS_CLICKED_CTA';
export const CTA_HAS_SEEN = 'HAS_OPENED_CTA';
export const CTA_NOT_HAS_CLICKED = 'HAS_NOT_CLICKED_CTA';
export const CTA_NOT_HAS_SEEN = 'HAS_NOT_OPENED_CTA';

// EMAIL
// Base Email operator, this is the operator type for all email operators, the
// others are sub events.
export const EMAIL_EVENT = 'EMAIL_EVENT';

// Suboperators
export const EMAIL_BOUNCED = 'BOUNCE';
export const EMAIL_CLICKED = 'CLICK';
export const EMAIL_MARKED = 'SPAMREPORT';
export const EMAIL_OPENED = 'OPEN';
export const EMAIL_OPENED_NOT_CLICKED = 'OPEN_NOT_CLICK';
export const EMAIL_OPENED_NOT_REPLIED = 'OPEN_NOT_REPLIED';
export const EMAIL_RECEIVED = 'DELIVERED';
export const EMAIL_RECEIVED_NOT_OPENED = 'DELIVERED_NOT_OPEN';
export const EMAIL_REPLIED = 'REPLIED';
export const EMAIL_SENT = 'SENT';
export const EMAIL_SENT_NOT_CLICKED = 'SENT_NOT_CLICK';
export const EMAIL_SENT_NOT_RECEIVED = 'SENT_NOT_DELIVERED';
export const EMAIL_UNSUBSCRIBED = 'UNSUBSCRIBED';

// EMAIL SUBSCRIPTIONS
export const HAS_OPTED_IN = 'OPT_IN';
export const HAS_OPTED_OUT = 'OPT_OUT';
export const HAS_NOT_OPTED = 'NOT_OPTED';

// EVENT
export const EVENT_HAS = 'HAS_EVENT';
export const EVENT_NOT_HAS = 'NOT_HAS_EVENT';

// FORM
export const FORM_FILLED_OUT = 'HAS_FILLED_OUT_FORM';
export const FORM_NOT_FILLED_OUT = 'HAS_NOT_FILLED_OUT_FORM';

// IMPORT
export const IN_IMPORT = 'IS_IN_IMPORT';
export const NOT_IN_IMPORT = 'IS_NOT_IN_IMPORT';

// INTEGRATION
export const INTEGRATION_OPERATOR = 'INTEGRATIONS_TIMELINE_EVENT';

// LIST
export const LIST_IN = 'IN_LIST';
export const LIST_NOT_IN = 'NOT_IN_LIST';

// PAGE VIEW
export const PAGEVIEW_CONTAINS = 'HAS_PAGEVIEW_CONTAINS';
export const PAGEVIEW_EQUAL = 'HAS_PAGEVIEW_EQ';
export const PAGEVIEW_MATCHES = 'HAS_PAGEVIEW_MATCHES_REGEX';
export const PAGEVIEW_NOT_CONTAINS = 'NOT_HAS_PAGEVIEW_CONTAINS';
export const PAGEVIEW_NOT_EQUAL = 'NOT_HAS_PAGEVIEW_EQ';
export const PAGEVIEW_NOT_MATCHES = 'NOT_HAS_PAGEVIEW_MATCHES_REGEX';

// SURVEY MONKEY
export const SURVEY_ANSWERED = 'HAS_ANSWERED_SURVEY_QUESTION';
export const SURVEY_NOT_RESPONDED = 'HAS_NOT_RESPONDED_TO_SURVEY';
export const SURVEY_RESPONDED = 'HAS_RESPONDED_TO_SURVEY';

// WEBINAR
export const WEBINAR_ATTENDED = 'HAS_WEBINAR_ATTENDANCE';
export const WEBINAR_REGISTERED = 'HAS_WEBINAR_REGISTRATION';
export const WEBINAR_NOT_ATTENDED = 'NOT_HAS_WEBINAR_ATTENDANCE';
export const WEBINAR_NOT_REGISTERED = 'NOT_HAS_WEBINAR_REGISTRATION';

// WORKFLOW
export const WORKFLOW_ACTIVE = 'ACTIVE_IN_WORKFLOW';
export const WORKFLOW_COMPLETED = 'COMPLETED_WORKFLOW';
export const WORKFLOW_ENROLLED = 'ENROLLED_IN_WORKFLOW';
export const WORKFLOW_MET_GOAL = 'MET_WORKFLOW_GOAL';
export const WORKFLOW_NOT_ACTIVE = 'NEVER_ACTIVE_IN_WORKFLOW';
export const WORKFLOW_NOT_COMPLETED = 'NEVER_COMPLETED_WORKFLOW';
export const WORKFLOW_NOT_ENROLLED = 'NEVER_ENROLLED_IN_WORKFLOW';
export const WORKFLOW_NOT_MET_GOAL = 'NEVER_MET_WORKFLOW_GOAL';